<template>
  <div
    class="height-all main-page"
    :class="{
      [`main-page--${createRenderType}`]: true,
      [`main-page-fullrouter--${
        route?.meta?.full || route?.query?.membership_source1 == 'activity'
      }`]: true,
      'main-page-summon-visible': headSummonVisible,
      [`main-page--${route?.name}`]: true,
      [`main-page-bottom-player-visible--${!!curPlayData}`]: true,
      [`main-page-scroll-custom`]: route?.meta?.scrollCustom ?? false,
      [`main-page--murekacn`]: GlobalConfig.appname == chinaAppName,
      [`main-page--${$$language()}`]: true,
      // headSummonVisible && $$language() != 'cn',
    }"
  >
    <div class="height-all main-page-content-box">
      <div class="main-page-content-bg" ref="refBgBox">
        <MainBg></MainBg>
      </div>
      <div class="main-page-content-lt-bg"></div>
      <div
        class="main-page-content-b-bg"
        v-if="createRenderType == 'mobile'"
      ></div>

      <div class="main-page-content height-all flex-column">
        <div class="main-header">
          <Header></Header>
        </div>
        <div class="main-body flex1 height-0 flex">
          <div class="main-nav">
            <div class="flex-column height-all flex-column">
              <div class="main-nav-box flex1 height-0">
                <Nav></Nav>
              </div>
              <div class="main-nav-swiper-banner">
                <SwiperBanner></SwiperBanner>
              </div>
              <ClubEntrance></ClubEntrance>
            </div>
          </div>
          <div class="main-content flex1">
            <div class="flex-column main-content-router-box">
              <div class="main-content-top flex1 height-0">
                <router-view
                  v-slot="{ Component, route }"
                  v-if="renderData.ifRender"
                >
                  <keep-alive>
                    <component :is="Component" v-if="route.meta.keepAlive" />
                  </keep-alive>
                  <component :is="Component" v-if="!route.meta.keepAlive" />
                </router-view>
              </div>

              <div
                class="main-footer"
                v-if="createRenderType != 'mobile'"
              >
                <Player></Player>
              </div>
              <div
                class="main-footer"
                :class="{
                  'main-footer-mobile': createRenderType == 'mobile',
                }"
                v-if="createRenderType == 'mobile'"
              >
                <MobilePlayer></MobilePlayer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <CreateEdit :initClose="true"></CreateEdit> -->
    <Credit v-model:showCredit="dialogStore.inviteFinishedDialog"></Credit>
    <VipPublishNotification
      :visible="feedListDataStore.release.showReleaseModal"
      v-if="feedListDataStore.release.showReleaseModal"
    ></VipPublishNotification>
    <ReleaseFormDialog
      v-if="feedListDataStore.release.showReleaseFormModal"
      :visible="feedListDataStore.release.showReleaseFormModal"
    ></ReleaseFormDialog>
    <ReleaseResultDialog
      :visible="feedListDataStore.release.showReleaseResultModal"
      v-if="feedListDataStore.release.showReleaseResultModal"
    ></ReleaseResultDialog>
    <ReleaseFailDialog
      :visible="feedListDataStore.release.showReleaseFailModal"
      v-if="feedListDataStore.release.showReleaseFailModal"
    ></ReleaseFailDialog>
    <!-- vocal功能引导弹窗 -->
    <VocalDialogs
      v-if="dialogStore.vocalDialog"
      v-model:visible="dialogStore.vocalDialog"
      v-model:isFirst="isFirst"
    ></VocalDialogs>
    <!-- 召回弹窗 -->
    <MailRecallDialog
      v-if="dialogStore.recallMailDialog"
      v-model:visible="dialogStore.recallMailDialog"
    ></MailRecallDialog>
    <!-- 检查订阅失败弹窗 -->
    <SubscriptionDialog
      v-if="showLastCheckModal"
      v-model:visible="showLastCheckModal"
    ></SubscriptionDialog>
    <!-- 音疯迁移公告 -->
    <YinfengDialog
      v-if="showYinfengModal"
      v-model:visible="showYinfengModal"
    ></YinfengDialog>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  reactive,
  watch,
  onMounted,
  onUnmounted,
} from "vue";
import GlobalConfig, { chinaAppName } from "@/config/config.js";

import ClubEntrance from "./clubEntrance.vue";
import { useRouter, useRoute } from "vue-router";
import Header from "./header.vue";
import Nav from "./nav.vue";
import Player from "./player.vue";
import MobilePlayer from "./mobilePlayer.vue";
import MainBg from "@/page/main/mainBg.vue";
import SwiperBanner from "./swiperBanner.vue";
import Credit from "./dialogs/credit.vue";
import VipPublishNotification from "@/page/create/feedSongOp/vipPublishNotification.vue";
import ReleaseFormDialog from "@/page/create/feedSongOp/releaseFormDialog.vue";
import ReleaseResultDialog from "@/page/create/feedSongOp/releaseResultDialog.vue";
import ReleaseFailDialog from "@/page/create/feedSongOp/releaseFailDialog.vue";
import VocalDialogs from "./dialogs/vocalDialog.vue";
import MailRecallDialog from "./dialogs/mailRecallDialog.vue";
import SubscriptionDialog from "./dialogs/subscriptionDialog.vue";
// import CreateEdit from "@/page/create/createEdit.vue";

import { $$language, $$t } from "@/i18n/i18n.js";
import useUserDataStore from "@/store/userDataStore";
import useFeedListStore from "@/store/create/feedListDataStore.js";
import useDialogStore from "@/store/dialogStore.js";
import YinfengDialog from "./dialogs/yinfengDialog.vue";
import { storeToRefs } from "pinia";
import useGlobalPlayDataStore from "@/store/globalPlayDataStore.js";

import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import { getCreditInfo } from "@/api/api/apiCredit.js";
import apiUser from "@/api/api/apiUser";

const feedListDataStore = useFeedListStore();
const userDataStore = useUserDataStore();

const createLayoutStore = useCreateLayoutStore();
const { showLastCheckModal } = storeToRefs(userDataStore);
const { createRenderType, headSummonVisible } = storeToRefs(createLayoutStore);
const { curPlayData } = storeToRefs(useGlobalPlayDataStore());

const dialogStore = useDialogStore();

const Router = useRouter();
const route = useRoute();

const props = defineProps({});
const emits = defineEmits([]);

const refBgBox = ref(null);
const renderData = reactive({
  ifRender: true,
  mainBgWidth: 0,
  mainBgHeight: 0,
  ifRenderFooter: true,
});
const vocalVisible = ref(false);
const isFirst = ref(true);
const showCredit = ref(false);
const showYinfengModal = ref(false);
const onResize = () => {
  renderData.ifRenderFooter = false;
  nextTick().then(() => {
    renderData.ifRenderFooter = true;
  });
};

watch(
  () => userDataStore.isLogin,
  (val) => {
    if (val) {
      dialogStore.getPopupShow();
      getCreditInfo().then((res) => {
        if (res.code == 200) {
          const { data } = res;
          userDataStore.setCreditsInfo(data);
        }
      });
      if (route.query?.mail_recall_key) {
        apiUser.giveMailRecallCredits({
          mail_recall_key: route.query?.mail_recall_key,
        });
      }
    } else {
      isFirst.value = true;
      userDataStore.setCreditsInfo({});
    }
  }
);

const isYinfengUser = () => {
  const Router = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties?.$router;
  const isYinfeng = Router?.currentRoute?.value?.query?.yinfeng_user === "true" && GlobalConfig.appname === chinaAppName;
  showYinfengModal.value = isYinfeng;
}

onMounted(() => {
  isYinfengUser()
  const Router = (getCurrentInstance() || (window?.$getVueCurrentInstance?.())).appContext?.config?.globalProperties?.$router
  renderData.route = Router?.currentRoute;
  renderData.mainBgWidth = refBgBox.value.width;
  renderData.mainBgHeight = refBgBox.value.height;
  renderData.resizeObserver = new ResizeObserver(onResize);
  renderData.resizeObserver?.observe(document.body);
  if (route.meta.title != "create") {
    dialogStore.getPopupShow();
  }

  if (route.query?.mail_recall_key && userDataStore.isLogin) {
    apiUser.giveMailRecallCredits({
      mail_recall_key: route.query?.mail_recall_key,
    });
  }
  if (GlobalConfig.appname == chinaAppName) {
    document.body.classList.add("murekacn");
  }
});

onUnmounted(() => {
  renderData.resizeObserver?.disconnect();
});
watch(
  () => {
    curPlayData.value;
  },
  () => {
  }
);
</script>
<style lang="scss">
.main-page {
  max-width: 100%;
  .main-page-content-box {
    background: #0e0124;
    position: relative;
  }
  .main-page-content-lt-bg {
    position: absolute;
    top: 0;
    left: 0;
    height: 405px;
    width: 256px;
    background: url(@/assets/img/header-lt-bg.png);
    background-size: 100% 100%;
    background-position: center center;
  }
  .main-page-content-b-bg {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 136px;
    background: linear-gradient(180deg, rgba(5, 16, 47, 0) 0%, #05102f 52%);
  }
  .main-page-content-bg {
    position: absolute;
    top: 16px;
    right: 16px;
    bottom: 0;
    left: 200px;
  }
  .main-page-content {
    position: absolute;
    height: 100%;
    width: 100%;
  }
  .main-body {
    /*height: calc(100% - 148px);*/
  }
  .main-nav {
    width: 200px;
    height: 100%;
    .main-nav-box {
      overflow-y: scroll;
    }
  }
  .main-content {
    margin: -48px 0 0 0;
    height: calc(100% + 48px);
    width: 0;
    overflow-x: scroll;
    .main-content-top{
      padding: 0 16px 0 0;
    }
    .main-content-router-box {
      height: 100%;
      width: 100%;
      min-width: 1140px;
      position: relative;
    }
  }
  .main-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    &.main-footer-mobile {
      background: linear-gradient(180deg, rgba(5, 16, 47, 0) 0%, #05102f 52%);
    }
  }
  &.main-page-summon-visible {
    .main-page-content-bg {
      top: 62px;
    }
    .main-content {
      margin: 0px 16px 0 0;
      height: calc(100% + 0px);
    }
  }

  &.main-page-scroll-custom {
    .main-content {
      overflow: unset !important;
    }
    .main-content-router-box {
      min-width: unset !important;
    }
    .bottom-player {
      .audio-item-info {
        flex: 1;
        width: 0;
        max-width: unset;
      }
      .audio-palyer-right {
        flex: 1;
        width: 0;
        min-width: max-content;
      }

      .audio-palyer-controls {
        min-width: 500px;
      }
    }
  }
  &.main-page--mobile {
    .main-page-content-lt-bg {
      position: absolute;
      top: 0;
      left: 0;
      height: 400px;
      width: 400px;
      display: none;
    }
    .main-page-content-bg {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      border-radius: 0;
      .main-bg-effect {
        border-radius: 0;
      }
    }
    .main-body {
      flex-direction: column-reverse;
    }
    .main-nav {
      display: block;
      width: 100%;
      height: 56px;
      overflow: hidden;
    }
    .main-nav-swiper-banner {
      display: none;
    }
    .main-nav-other {
      display: none;
    }
    .main-content {
      width: 100%;
      margin: 0;
      height: 0;
      overflow: visible;
    }
    .main-content-top{
      padding: 0;
    }
    .main-content-router-box {
      max-width: 100%;
      min-width: unset;
    }
    &.main-page-fullrouter--true {
      .main-header {
        display: none;
      }
      .main-nav {
        display: none;
      }
      .main-body {
        margin-bottom: 0;
      }
    }
    &.main-page-fullrouter--hidenav {
      .main-nav {
        display: none;
      }
      .main-body {
        margin-bottom: 0;
      }
    }
    .wrapper .wrapper-create {
      padding: 18px 0 10px 0 !important;
      margin: 0 16px;
      overflow-x: auto;
      width: unset;
      display: none;
      .wrapper-create-btn {
        min-width: 114px;
      }
    }
    &.main-page--instrumental,
    &.main-page--create,
    &.main-page--editor,
    &.main-page--createIndex {
      .wrapper .wrapper-create {
        display: flex;
      }
      .mescroll-upwarp {
        padding: 15px 0 85px 0;
      }
    }
  }
}
</style>
